import { Map } from 'immutable';

import { ATTRIBUTE } from '../../../../constants/attributes';

export function shipping({ attribute, preview }) {
  return {
    payload: Map({
      type: preview.getIn([ATTRIBUTE.SHIPPING, 'operation']),
      value: preview.getIn([ATTRIBUTE.SHIPPING, attribute]),
    }),
  };
}
